import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var StopScenario;
(function (StopScenario) {
    let Type;
    (function (Type) {
        Type[Type["RETURN"] = 0] = "RETURN";
        Type[Type["BREAK"] = 1] = "BREAK";
        Type[Type["CONTINUE"] = 2] = "CONTINUE";
    })(Type = StopScenario.Type || (StopScenario.Type = {}));
    StopScenario.get = createAccessors(arrayGetSet('stop_scenarios'), {
        type: StopScenario.Type.RETURN,
        return_id: null,
    });
})(StopScenario || (StopScenario = {}));
